"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AnimationLayer_1 = require("./AnimationLayer");
var ShapeElement_1 = require("../shapes/ShapeElement");
var ShapeElementFactory_1 = require("../shapes/ShapeElementFactory");
var ShapeLayer = (function (_super) {
    tslib_1.__extends(ShapeLayer, _super);
    function ShapeLayer(rawData, version) {
        var _this = _super.call(this, rawData, version) || this;
        _this.findFirstFill = function () {
            return _this.findFirstFillShape(_this);
        };
        _this.findFillColor = function () {
            var fill = _this.findFirstFill();
            if (fill != null) {
                return fill.color.value;
            }
            return null;
        };
        _this.replaceFillColor = function (color) {
            var fill = _this.findFirstFill();
            if (fill != null) {
                for (var i = 0; i < color.length; i++) {
                    fill.color.value[i] = color[i];
                }
            }
        };
        _this.findFirstFillShape = function (shapeContainer) {
            for (var i = 0; i < shapeContainer.shapes.length; i++) {
                var candidate = shapeContainer.shapes[i];
                if (candidate.type === ShapeElement_1.ShapeElementType.Fill) {
                    return candidate;
                }
                else if (candidate.type === ShapeElement_1.ShapeElementType.Group) {
                    var group = candidate;
                    var fill = _this.findFirstFillShape(group);
                    if (fill != null) {
                        return fill;
                    }
                }
            }
            return null;
        };
        _this.shapes = _this._rawData.shapes.map(function (rawShapeElementData) {
            return ShapeElementFactory_1.constructShapeElementFromRawData(rawShapeElementData, version);
        });
        return _this;
    }
    return ShapeLayer;
}(AnimationLayer_1.AnimationLayer));
exports.ShapeLayer = ShapeLayer;
//# sourceMappingURL=ShapeLayer.js.map